import { Component, OnInit, Input, Output,EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import * as firebase from 'firebase';
import { AlertService } from '../../../_services/alert.service';
import { v4 as uuidv4 } from 'uuid';
import * as _ from 'underscore';
import Swal from 'sweetalert2/dist/sweetalert2.js';
@Component({
  selector: 'app-meals-activity',
  templateUrl: './meals-activity.component.html',
  styleUrls: ['./meals-activity.component.css']
})
export class MealsActivityComponent implements OnInit {
  modalRef: any;
  iconTab: FormGroup;
  meals = ['Yes', 'No'];
  members = ['Walter White', 'Jessy Pinkman', 'Heisenberg', 'Skylar White', 'Saul Goodman']
  modes = ['Bus', 'Train']
  mealTypes = ['Personal', 'Client', 'Team']
  mealSession = ['Breakfast', 'Lunch', 'Dinner', 'Others']

  private activityList: Array<any> = [];
  tagList = [];
  snapList: any = [];
  isLoading: any = false;
  isUploading: any = false;
  selectedItems = [];
  diffList = [];
  dropdownSettings = {};
  keyIndex: any = -1;
  minDate: any;
  maxDate: any;
  startDate: any;
  currMinDate: any;
  currMaxDate: any;
  addedBy: any;
  verifyFields = [
    {
      "key": "meetingMealsPurpose",
      "value": "MeetingMealsPurpose"
    },
    {
      "key": "meetingStartDate",
      "value": "MealsStartDate",
      "isDate": true
    },
    {
      "key": "meetingEndDate",
      "value": "MealsEndDate",
      "isDate": true
    },
    {
      "key": "meetMealsLocation",
      "value": "MeetMealsLocation"
    },
    {
      "key": "meatMealSession",
      "value": "MeatMealSession"
    },
    {
      "key": "meetMealType",
      "value": "MeetMealType"
    },
    {
      "key": "startTimeMeetMeals",
      "value": "StartTimeMeetMeals"
    },
    {
      "key": "endTimeMeetMeals",
      "value": "EndTimeMeetMeals"
    },
    {
      "key": "meetingReservation",
      "value": "MeetingReservation"
    },
    {
      "key": "tagMembersMeetMeals",
      "value": "TagMembersMeetMeals"
    },
    {
      "key": "otherInfoMeetMeals",
      "value": "OtherInfoMeetMeals"
    },
    {
      "key": "transNumberMeetMeals",
      "value": "TransNumberMeetMeals"
    },
    {
      "key": "merchNameMeetMeals",
      "value": "MerchNameMeetMeals"
    }
  ]

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private alertService: AlertService
  ) {
    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
    this.maxDate = {
      year: current.getFullYear(),
      month: current.getMonth(),
      day: current.getDate(),
    };
  }

  @Input() data: any;
  @Input() travellers: any;
  @Input() createdBy: any;
  @Input() code: any;
  @Input() isReadOnly: any;
  @Input() isDisabled: any;
  @Input() isActivityEdit: any;
  @Output() flightData: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {
    this.iconTab = this.formBuilder.group({
      activityDetails: [[]],

      // MeetMeals Activity
      meetingMealsPurpose: ['', Validators.required],
      meetMealsLocation: ['', Validators.required],
      meetingStartDate: ['', Validators.required],
      meetingEndDate: ['', Validators.required],
      // mealsStartDate: ['', Validators.required],
      // mealsEndDate: ['', Validators.required],
      meetingStart: ['', Validators.required],
      meetingEnd: ['', Validators.required],
      startTimeMeetMeals: ['', Validators.required],
      endTimeMeetMeals: ['', Validators.required],
      paidbyMeals: ['', Validators.required],
      tagMembersMeetMeals: ['', Validators.required],
      otherInfoMeetMeals: ['', Validators.required],
      transNumberMeetMeals: ['', Validators.required],
      merchNameMeetMeals: ['', Validators.required],
      meatMealSession: ['', Validators.required],
      otherMeatMealSession: ['', Validators.required],
      meetMealType: ['', Validators.required],
      meetingReservation: ['', Validators.required],
      createdBy: ['', Validators.required],
    });

    this.tagList = this.travellers;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.iconTab.patchValue(this.data);
    this.addedBy = this.data ? this.data.createdBy : this.createdBy;
    this.createdBy = this.data ? this.data.createdBy : this.createdBy + " - " + this.code;
    this.snapList = this.data ? this.data.snapList : '' || [];
    this.diffList = this.data && this.data.activityDiffList || [];
    this.selectedItems = this.data ? this.data.tagMembersMeetMeals : '' || [];
    console.log('diffList --', this.diffList)
  }

  get f() {
    return this.iconTab.controls;
  }

  getDiffItem(key: any, val: any) {
    let d = _.groupBy(this.diffList, 'key')[key]
    if (d && d.length) {
      return d[0][val]
    }
  }

  displayMembers(allMembers: any) {
    console.log(allMembers);
    allMembers = allMembers.toString().replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,',  ');
    return allMembers;
  }

  // Meeting/Meals activity
  meetingMealsActivity() {
    // this.isLoading = true
    this.activityList.push({
      category: "Meeting v/s Meals",
      meetingMealsPurpose: this.iconTab.value.meetingMealsPurpose,
      meetMealsLocation: this.iconTab.value.meetMealsLocation,
      meetingStartDate: this.iconTab.value.meetingStartDate,
      meetingEndDate: this.iconTab.value.meetingEndDate,
      meetingStart: this.iconTab.value.meetingStart,
      meetingEnd: this.iconTab.value.meetingEnd,
      startTimeMeetMeals: this.iconTab.value.startTimeMeetMeals,
      endTimeMeetMeals: this.iconTab.value.endTimeMeetMeals,
      paidbyMeals: this.iconTab.value.paidbyMeals,
      tagMembersMeetMeals: this.iconTab.value.tagMembersMeetMeals,
      otherInfoMeetMeals: this.iconTab.value.otherInfoMeetMeals,
      transNumberMeetMeals: this.iconTab.value.transNumberMeetMeals,
      merchNameMeetMeals: this.iconTab.value.merchNameMeetMeals,
      meatMealSession: this.iconTab.value.meatMealSession,
      meetMealType: this.iconTab.value.meetMealType,
      meetingReservation: this.iconTab.value.meetingReservation,
    })
    this.iconTab.patchValue({
      activityDetails: this.activityList,
      category: "Meeting v/s Meals",
      meetingMealsPurpose: '',
      meetMealsLocation: '',
      meetingStartDate: '',
      meetingEndDate: '',
      meetingStart: '',
      meetingEnd: '',
      startTimeMeetMeals: '',
      endTimeMeetMeals: '',
      paidbyMeals: '',
      tagMembersMeetMeals: '',
      otherInfoMeetMeals: '',
      transNumberMeetMeals: '',
      merchNameMeetMeals: '',
      meatMealSession: '',
      meetMealType: '',
      meetingReservation: '',
    })
  }

  editMeetMealsActivity(index, content) {
    this.modalRef = this.modalService.open(content, { windowClass: 'animated fadeInDown', size: 'lg' });
    this.keyIndex = index;
    this.iconTab.patchValue({
      meetingMealsPurpose: this.activityList[index].meetingMealsPurpose,
      meetMealsLocation: this.activityList[index].meetMealsLocation,
      meetingStartDate: this.activityList[index].meetingStartDate,
      meetingEndDate: this.activityList[index].meetingEndDate,
      meetingStart: this.activityList[index].meetingStart,
      meetingEnd: this.activityList[index].meetingEnd,
      startTimeMeetMeals: this.activityList[index].startTimeMeetMeals,
      endTimeMeetMeals: this.activityList[index].endTimeMeetMeals,
      paidbyMeals: this.activityList[index].paidbyMeals,
      tagMembersMeetMeals: this.activityList[index].tagMembersMeetMeals,
      otherInfoMeetMeals: this.activityList[index].otherInfoMeetMeals,
      transNumberMeetMeals: this.activityList[index].transNumberMeetMeals,
      merchNameMeetMeals: this.activityList[index].merchNameMeetMeals,
      meatMealSession: this.activityList[index].meatMealSession,
      meetMealType: this.activityList[index].meetMealType,
      meetingReservation: this.activityList[index].meetingReservation,
    });
    this.selectedItems = this.activityList[index].tagMembersMeetMeals
  }

  upDateMeetMealsActivity() {
    this.activityList[this.keyIndex] = {
      category: 'Meeting v/s Meals',
      meetingMealsPurpose: this.iconTab.value.meetingMealsPurpose,
      meetMealsLocation: this.iconTab.value.meetMealsLocation,
      meetingStartDate: this.iconTab.value.meetingStartDate,
      meetingEndDate: this.iconTab.value.meetingEndDate,
      meetingStart: this.iconTab.value.meetingStart,
      meetingEnd: this.iconTab.value.meetingEnd,
      startTimeMeetMeals: this.iconTab.value.startTimeMeetMeals,
      endTimeMeetMeals: this.iconTab.value.endTimeMeetMeals,
      paidbyMeals: this.iconTab.value.paidbyMeals,
      tagMembersMeetMeals: this.iconTab.value.tagMembersMeetMeals,
      otherInfoMeetMeals: this.iconTab.value.otherInfoMeetMeals,
      transNumberMeetMeals: this.iconTab.value.transNumberMeetMeals,
      merchNameMeetMeals: this.iconTab.value.merchNameMeetMeals,
      meatMealSession: this.iconTab.value.meatMealSession,
      meetMealType: this.iconTab.value.meetMealType,
      meetingReservation: this.iconTab.value.meetingReservation,
    };

    this.iconTab.patchValue({
      activityDetails: this.activityList,
      meetingMealsPurpose: '',
      meetMealsLocation: '',
      meetingStartDate: '',
      meetingEndDate: '',
      meetingStart: '',
      meetingEnd: '',
      startTimeMeetMeals: '',
      endTimeMeetMeals: '',
      paidbyMeals: '',
      tagMembersMeetMeals: '',
      otherInfoMeetMeals: '',
      transNumberMeetMeals: '',
      merchNameMeetMeals: '',
      meatMealSession: '',
      meetMealType: '',
      meetingReservation: '',
    });
    this.keyIndex = -1;
  }

  selectMealsStartDate(event) {
    console.log(event);
    this.startDate = event;
    let year = event.year;
    let month = event.month <= 9 ? '0' + event.month : event.month;;
    let day = event.day <= 9 ? '0' + event.day : event.day;;
    let finalDate = day + "-" + month + "-" + year;
    this.iconTab.patchValue({
      meetingStartDate: finalDate
    })
    this["meetingStart"] = finalDate;
  }

  selectMealsEndDate(event) {
    console.log(event);
    let year = event.year;
    let month = event.month <= 9 ? '0' + event.month : event.month;;
    let day = event.day <= 9 ? '0' + event.day : event.day;;
    let finalDate = day + "-" + month + "-" + year;
    this.iconTab.patchValue({
      meetingEndDate: finalDate
    })
    this["meetingEnd"] = finalDate;
  }

  getMinDate() {
    if (this.startDate) {
      return (this.startDate)
    } else {
      return this.minDate
    }
  }

  readableDateFormat(userDate: any) {
    if (!_.isObject(userDate)) {
      return userDate;
    } else {
      let year = userDate.year;
      let month = userDate.month <= 9 ? '0' + userDate.month : userDate.month;;
      let day = userDate.day <= 9 ? '0' + userDate.day : userDate.day;;
      let finalDate = day + "-" + month + "-" + year;
      return finalDate;
    }
  }

  addNewItem() {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Save?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
    if (!this.iconTab.value.meetingMealsPurpose || !this.iconTab.value.meetMealsLocation || !this.iconTab.value.meatMealSession
      || !this.iconTab.value.meetMealType || !this.iconTab.value.meetingStart || !this.iconTab.value.startTimeMeetMeals
      || this.iconTab.value.tagMembersMeetMeals.length == 0) {
      this.alertService.showError('Mandatory fields to be filled !');
      return false;
    }

    let isMatch = _.isMatch(this.data, this.iconTab.value);
    if (isMatch && this.isActivityEdit) {
      this.alertService.showError('No Changes made to amend !', 3000, 'Invalid update !')
      return false;
    }

    let activityDiffList = [];
    if(!isMatch && this.isActivityEdit){
      let that = this;
      let old = _.clone(this.data), fresh = _.clone(this.iconTab.value);
      _.each(this.verifyFields, function(field){
        let newVal = fresh[field.key], oldVal = old[field.key];
        if (old[field.key] != fresh[field.key]){

          // if (field.key == 'meals' && newVal == 'No') {
          //   newVal = fresh['meals']
          // } else {
          //   newVal = fresh['meals']
          // }

          activityDiffList.push({
            key: field.key,
            name: field.value,
            oldVal: field.isDate ? that.readableDateFormat(old[field.key]) : oldVal,
            newVal: field.isDate ? that.readableDateFormat(fresh[field.key]) : newVal
          })
        }
      })
    }

    console.log('am in addNewItem ', activityDiffList, this.activityList, this.iconTab.value);
    this.flightData.emit({...this.iconTab.value, activityDiffList: activityDiffList, snapList: this.snapList, category:'Meeting w/ Meals', uniqueId: uuidv4(), addedBy: this.addedBy, key: this.code});
    this.closeModal();
  }
})
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  chooseFile() {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Upload Confirmation Doc?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
    document.getElementById("avatar").click();
  }
})
  }

  upload() {
    // Create a root reference
    let storageRef = firebase.storage().ref();
    this.isUploading = true;
    let that = this;

    for (let selectedFile of [(<HTMLInputElement>document.getElementById('avatar')).files[0]]) {
      // let path = '/BILLS/' + Date.now() + `${selectedFile.name}`;
      let path = '/BILLS/' + Date.now() + '_' + `${selectedFile.name}`;
      let iRef = storageRef.child(path);
      iRef.put(selectedFile).then((snapshot) => {
        snapshot.ref.getDownloadURL()
          .then((url) => {
            let images = that.snapList || [];
            images.push(url);
            that.snapList = images;
            this.isUploading = false;
          })
      });
    }
  }

  removeImage(index: any) {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Remove?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
    this.snapList.splice(index, 1);
  }
})
  }

  getFileName(url: any) {
    let data = '';
    if (url.split('_')[1]) {
      data = url.split('_')[1].split('?');
      data = data[0] ? decodeURI(data[0]) : '';
      return data;
    } else {
      return data;
    }
  }
}
